/* eslint-disable import/no-anonymous-default-export */
import accessServices from '../services/access'

const loginLogic = async (username, password) => {
    const dataResp = accessServices.loginService(username, password);
    return dataResp;
}

const setPaswordLinkLogic = async (email, link) => {
    const dataResp = accessServices.setPaswordLink(email, link);
    return dataResp;
}

const changePasswordLogic = async (password, passwordConfirm, token) => {
    const dataResp = accessServices.changePassword(password, passwordConfirm, token);
    return dataResp;
}

export default {
    loginLogic,
    setPaswordLinkLogic,
    changePasswordLogic
}
